import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Table, DialogContent, DialogActions, Alert, Snackbar, tableCellClasses, Button, Box, IconButton, Select, MenuItem, DialogTitle, Dialog } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import api, { fetchProductionNewInstallations, updateProductionNewInstallation, emailProductionNewInstallationPdf, fetchCustomers, fetchVehicles, fetchSolutions, fetchSalesNewInstallation } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';
import { z } from "zod";
import { FormModal, RHFTextField } from "../components/form";

export function Production() {
    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
    const [sendingEmailId, setSendingEmailId] = React.useState(null);
    const [selectedSale, setSelectedSale] = React.useState(null);
    const [saleModalOpen, setSaleModalOpen] = React.useState(false);
    const [haulierOptions, setHaulierOptions] = React.useState([]);
    const [truckOptions, setTruckOptions] = React.useState([]);
    const [devicesOptions, setDevicesOptions] = React.useState([]);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};

    const handleViewSaleDetail = async (saleId) => {
        try {
            const response = await fetchSalesNewInstallation(saleId);
            console.log(response.data);

            setSelectedSale(response.data);
            setSaleModalOpen(true);
        } catch (error) {
            console.error("Failed to fetch sale detail:", error);
        }
    };
    const fetchDevices = async () => {
        try {
            const response = await fetchSolutions();
            const deviceDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.name;
                return acc;
            }, {});
            setDevicesOptions(deviceDict)
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };
    const fetchTruck = async () => {
        try {
            const response = await fetchVehicles();
            const haulierDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.registration_number;
                return acc;
            }, {});
            setTruckOptions(haulierDict)
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };
    const fetchHauliers = async () => {
        try {
            const response = await fetchCustomers();
            const haulierDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.name;
                return acc;
            }, {});
            console.log(haulierDict);

            setHaulierOptions(haulierDict)
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };
    const fetchTrucks = async () => {
        try {
            const response = await fetchProductionNewInstallations();
            setProductionData(response.data);
            showSnackbar('Production fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching production';
            showSnackbar(`Failed to fetch production: ${errorMessage}`, 'error');
        }
    };

    const handleSendEmail = async (saleId) => {
        setSendingEmailId(saleId);

        try {
            await emailProductionNewInstallationPdf(saleId, {});
            alert("Email sent successfully!");
        } catch (error) {
            console.error("Email error:", error);
            alert("Failed to send email.");
        } finally {
            setSendingEmailId(null);
        }
    };

    React.useEffect(() => {
        fetchTrucks();
        fetchDevices()
        fetchHauliers()
    }, []);

    const showSnackbar = (message, severity) => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const [productionData, setProductionData] = React.useState([])
    const [modalOpen, setModalOpen] = React.useState(false);
    // Save productionData to localStorage on update
    React.useEffect(() => {
        localStorage.setItem('production', JSON.stringify(productionData));
        console.log(productionData, 'productionData');

    }, [productionData]);

    const handleOpen = () => setModalOpen(true);
    const handleClose = () => setModalOpen(false);
    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const [selectedProduction, setSelectedProduction] = React.useState(null);
    const handleEditOn = (device) => {
        setSelectedProduction(device);
        setEditModalOpen(true);
    };

    const handleEditClose = () => {
        setEditModalOpen(false);
        setSelectedProduction(null);
    };
    const handleDelete = async (id) => {
        try {
            await api.delete(`/production-new-installation/${id}/`);
            showSnackbar("Customer deleted successfully", "success");
        } catch (error) {
            showSnackbar("Failed to delete customer", "error");
            console.error(error);
        }
    };

    const handleSave = async (newEmployee) => {
        try {
            const response = await api.post('/production-new-installation/', newEmployee);
            setProductionData((prev) => [...prev, response.data]);
        } catch (error) {
            console.error("Error saving employee:", error);
        }
    };

    const handleExport = () => {
        const doc = new jsPDF('l', 'mm', 'a3');

        // Title
        doc.setFontSize(18);
        doc.text('Production New Installation Report', 14, 16);

        // Columns (match the table headers)
        const columns = [
            'Production #',
            'Sale #',
            'Document',
            'Remarks',
            'Close At',
        ];

        // Table Data (map to match your table body)
        const tableData = productionData.map((sale) => [
            sale.id,
            sale.sale?.id || '',
            sale.document_url ? 'Available' : 'Not Available', // or full URL if you prefer
            sale.remarks || '',
            sale.status === 'Complete'
                ? sale.updated_at?.slice(0, 19).replace('T', ' ')
                : '',
        ]);

        // Generate table
        doc.autoTable({
            head: [columns],
            body: tableData,
            startY: 30,
            styles: {
                fontSize: 9,
                cellPadding: 2,
            },
            columnStyles: {
                0: { cellWidth: 30 },  // Production #
                1: { cellWidth: 30 },  // Sale #
                2: { cellWidth: 40 },  // Document
                3: { cellWidth: 70 },  // Remarks
                4: { cellWidth: 40 },  // Close At
            },
            theme: 'grid',
            didDrawPage: function () {
                doc.setFontSize(18);
                doc.text('Production Report', 14, 16);
            },
        });

        doc.save('Production_New_Installation_Report.pdf');
    };
    const EditProductionModal = ({ open, handleClose, device }) => {
        return (
            <FormModal
                open={open}
                onClose={handleClose}
                title="Edit Production"
                schema={z.object({ remarks: z.string().optional() })}
                defaultValues={{ remarks: device?.remarks ?? "" }}
                onSubmit={async (data) => {
                    const fd = new FormData();
                    Object.entries(data).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== "") fd.append(k, v); });
                    try {
                        await updateProductionNewInstallation(device.id, fd);
                        showSnackbar("Production updated successfully", "success");
                        fetchTrucks();
                    } catch (err) {
                        showSnackbar("Production update failed", "error");
                        throw err;
                    }
                }}
                submitLabel="Update"
                width={400}
            >
                {({ control }) => (
                    <>
                        <Box sx={{ mb: 2.5, pb: 1.5, borderBottom: "1px solid", borderColor: "divider", display: "flex", gap: 3, flexWrap: "wrap" }}>
                            <Typography variant="caption" color="text.secondary">Created: {device?.created_at?.slice(0, 19).replace("T", " ")}</Typography>
                            <Typography variant="caption" color="text.secondary">Updated: {device?.updated_at?.slice(0, 19).replace("T", " ")}</Typography>
                        </Box>
                        <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={4} />
                    </>
                )}
            </FormModal>
        );
    };

    const updateProduction = async (updatedProduction, id) => {
        const formData = new FormData();
        for (const key in updatedProduction) {
            formData.append(key, updatedProduction[key]);
        }
        try {
            await updateProductionNewInstallation(id, formData);
            showSnackbar('Production updated successfully', 'success');
        } catch (error) {
            showSnackbar('Failed to update device', 'error');
        }
    };
    const handleStatusChange = async (saleId, newStatus, sale) => {
        const updatedSale = { ...sale, status: newStatus };

        try {
            await updateProductionNewInstallation(saleId, updatedSale);

            // Update state in frontend
            setProductionData((prevData) =>
                prevData.map((item) =>
                    item.id === saleId ? { ...item, status: newStatus } : item
                )
            );

            showSnackbar('Status updated successfully', 'success');
        } catch (error) {
            console.error('Failed to update status:', error);
            showSnackbar('Failed to update status', 'error');
        }
    };

    return (
        <Container maxWidth="xl" sx={{ m: 2 }}>
            {editModalOpen && selectedProduction && <EditProductionModal open={editModalOpen} handleClose={handleEditClose} device={selectedProduction} />}
            <DataTable
                title="Production New Installation"
                columns={[
                    { key: 'id', label: 'Production #' },
                    { key: 'sale_id', label: 'Sale #', render: (s) => <span onClick={() => handleViewSaleDetail(s.sale.id)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}>{s.sale.id}</span> },
                    { key: 'document_url', label: 'Document', render: (s) => s.document_url ? <a href={`https://crm-backend.monit.tech/${s.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a> : <span style={{ color: '#999' }}>Not Available</span> },
                    { key: 'remarks', label: 'Remarks' },
                    { key: 'close_at', label: 'Close At', render: (s) => s.status === 'Complete' ? s.updated_at?.slice(0, 19).replace('T', ' ') : '' },
                ]}
                rows={productionData}
                toolbarActions={<Button variant="contained" color="primary" onClick={handleExport}>Export to PDF</Button>}
                renderActions={(sale) => (
                    <>
                        <IconButton color="secondary" size="small" onClick={() => handleEditOn(sale)} sx={{ p: '6px' }} disabled={sale.status === 'Complete'}><EditIcon /></IconButton>
                        <IconButton color="error" size="small" onClick={() => handleDeleteClick(sale.id)} sx={{ p: '6px', ml: '4px' }} disabled={sale.status === 'Complete'}><DeleteIcon /></IconButton>
                        <IconButton color="primary" size="small" onClick={() => handleSendClick(sale.id)} sx={{ p: '6px', ml: '4px' }} disabled={sendingEmailId === sale.id}>
                            {sendingEmailId === sale.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                        </IconButton>
                        <Select value={sale.status} onChange={(e) => handleStatusChange(sale.id, e.target.value, sale)} size="small" sx={{ ml: 1, minWidth: 100 }}>
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="Complete">Complete</MenuItem>
                        </Select>
                    </>
                )}
            />
                {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
            <Dialog open={saleModalOpen} onClose={() => setSaleModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Sale Details</DialogTitle>
                <DialogContent>
                    {selectedSale ? (
                        <Box>
                            <Typography variant="body1"><strong>Customer:</strong> {haulierOptions[selectedSale.customer]}</Typography>
                            <Typography variant="body1"><strong>Solution:</strong> {devicesOptions[selectedSale.solution]}</Typography>
                            <Typography variant="body1"><strong>Corporate:</strong> {selectedSale.corporate}</Typography>
                            <Typography variant="body1"><strong>POC Name:</strong> {selectedSale.poc_name}</Typography>
                            <Typography variant="body1"><strong>POC Contact:</strong> {selectedSale.poc_contact}</Typography>
                            <Typography variant="body1"><strong>Plan:</strong> {selectedSale.plan}</Typography>
                            <Typography variant="body1"><strong>Unit:</strong> {selectedSale.unit}</Typography>
                            <Typography variant="body1"><strong>Features:</strong> {selectedSale.features}</Typography>
                        </Box>
                    ) : (
                        <Typography variant="body2">Loading...</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setSaleModalOpen(false)} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}

